var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "width": "500px",
      "title": "Alipay Config",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "top": "6vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "label-width": "94px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "QR Code",
      "prop": "alipayQrcodeUrl"
    }
  }, [_c('el-image-uploader', {
    model: {
      value: _vm.dataForm.alipayQrcodeUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "alipayQrcodeUrl", $$v);
      },
      expression: "dataForm.alipayQrcodeUrl"
    }
  })], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("Submit")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }